import styled, { css } from 'styled-components';
import { rem } from 'polished';
var ItemLink = styled.a.withConfig({
  displayName: "ItemLink",
  componentId: "sc-1sgv277-0"
})(["&,&:hover,&:focus,&:active{outline:0;text-decoration:none;}display:block;", " ", ""], function (_ref) {
  var orientation = _ref.orientation;
  return orientation === 'landscape' && css(["max-width:", ";"], rem(300));
}, function (_ref2) {
  var orientation = _ref2.orientation;
  return orientation === 'portrait' && css(["max-width:", ";"], rem(148));
});
export default ItemLink;